
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NotificationSetting, NotificationChannelType, NotificationChannelSetting } from 'ah-api-gateways';
import cloneDeep from 'lodash/cloneDeep';

@Component
export default class SingleNotificationChannelEditForm extends Vue {
  @Prop({ default: false }) showTitles!: boolean | string;

  @Prop({ required: true }) notification!: NotificationSetting;

  @Prop({ required: true }) channels!: NotificationChannelSetting[];

  get titlesShown() {
    return this.showTitles !== false;
  }

  get NotificationChannelType() {
    return NotificationChannelType;
  }

  get isTargettingEmail() {
    return !!this.notification?.channels?.find((e) => e.type === NotificationChannelType.EMAIL && e.enabled);
  }

  get isTargettingInApp() {
    return !!this.notification?.channels?.find((e) => e.type === NotificationChannelType.IN_APP && e.enabled);
  }

  get isTargettingSms() {
    return !!this.notification?.channels?.find((e) => e.type === NotificationChannelType.SMS && e.enabled);
  }

  get isConfigurable() {
    return (channelType: NotificationChannelType) => {
      const channel = this.channels.filter((channel) => channel.channelType === channelType)![0];
      if (!channel.editable) return null;
      return channel.configurable;
    };
  }

  get defaultValue() {
    return (channelType: NotificationChannelType) => {
      const channel = this.channels.filter((channel) => channel.channelType === channelType)![0];
      return channel.defaultEnabledValue;
    };
  }

  onTargetChange(type: NotificationChannelType, enabled: boolean) {
    const channels = cloneDeep(this.notification?.channels || []);
    const index = channels.findIndex((i) => i.type === type);
    if (index === -1) {
      channels.push({ type, enabled });
    } else {
      channels[index].enabled = enabled;
    }
    this.$emit('update:notification', { ...this.notification, channels });
  }
}
